/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
//

document.addEventListener("DOMContentLoaded", function () {
  const mobileemojis = document.querySelectorAll(".mobilemoji");

  function isTouchDevice() {
    return (
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0
    );
  }

  if (isTouchDevice()) {
    console.log("The client is a touch device.");

    mobileemojis.forEach(function (element) {
      // console.log(element);
      element.style.display = "block";
    });
  } else {
    // console.log("The client is not a touch device.");
  }

  let pOffScreen = document.querySelector(".Product__OffScreen");
  let variationsBtn = document.querySelector(".ProductForm__Item");
  let variationsheight = document.querySelector(".ProductForm__Item");

  // console.log("pOffScreen", pOffScreen);
  // console.log("variationsBtn", variationsBtn);

  if (pOffScreen) {
    variationsBtn.addEventListener("click", function () {
      openClose();
    });

    function openClose() {
      if (pOffScreen.classList.contains("open")) {
        pOffScreen.classList.remove("open");
        pOffScreen.classList.add("closed");
        pOffScreen.style.height = "0px";
      } else {
        pOffScreen.classList.remove("closed");
        pOffScreen.classList.add("open");
        // update this, we need a flexible height!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
        pOffScreen.style.height = "230px";
      }
    }
  }

  // Your JavaScript code here
  // This code will run when the DOM has finished loading

  var myProductItem = document.querySelector(".ProductItem");
  myProductItem.style.transform = "none !important";
  myProductItem.style.opacity = "1 !important";
  myProductItem.style.visibility = "visible !important";

  let pList = document.querySelector(".ProductListWrapper");
  let pListItems = pList.querySelectorAll(".AspectRatio");

  pListItems.forEach(function (item) {
    let w = item.offsetWidth;
    item.style.height = w + "px";
  });

  window.addEventListener("resize", function () {
    pListItems.forEach(function (item) {
      let w = item.offsetWidth;
      item.style.height = w + "px";
    });
  });

  let overlays = document.querySelectorAll(".overlay");

  for (var i = 0; i < overlays.length; i++) {
    let overlay = overlays[i];
    overlay.addEventListener("mouseenter", function () {
      overlay.style.opacity = 1;
    });
    overlay.addEventListener("mouseleave", function () {
      overlay.style.opacity = 0;
    });
  }

  window.addEventListener("resize", function () {
    overlay.style.opacity = 1;
  });
});

window.addEventListener("resize", () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
});

window.onload = function () {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};
